import axios from "axios";
import {baseURL} from "../config/api";

export const getFaqs = () => {
    return axios({
        url: baseURL + "faqs",
        method: "GET"
    }).then(response => response.data);
};
